import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import * as actions from '../../store/actions';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    copyrightWaiverWrapper: {
        textAlign: 'center',
        marginTop: '60px',
        marginBottom: '40px',
    },
    copyrightWaiver: {
        textAlign: 'justify',
        lineHeight: '1.5rem',
        padding: '0rem 5rem',
        color: '#1c4257',
        marginBottom: '20px',
    },
    button: {
        fontSize: '1rem',
    },
}));

const GraphicsUploadConsent = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { t } = useTranslation();

    const handleSubmit = () => {
        dispatch(actions.graphicUploadConsentAccept());
    };

    return (
        <>
            <div className={classes.copyrightWaiverWrapper}>
                <p className={classes.copyrightWaiver}>
                    {t(
                        'In order to use an image, graphic or design you must own the complete rights on that image, graphic and/or design. With uploading of images, graphics or designs you as a customer confirm legally binding , that you own the exclusive rights of those images, graphics and/or designs. Furthermore you confirm to the following: I own the commerical rights to reproduce the image, the graphic and/or design. If for any reason the legal owner of this image, graphic and/or designs demands legal claims, those would be against me automatically. I understand, that the legal use of copyrighted material of third parties is an indictable offence and can be sentenced. Hereby, with clicking on ACCEPT, I declare that I have the permission to use this file.'
                    )}
                </p>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleSubmit}
                    className={classes.button}
                >
                    {t('Accept')}
                </Button>
            </div>
        </>
    );
};

export default GraphicsUploadConsent;
